import React from 'react';

import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import styled from 'styled-components';

import { AntdTableExpandIcon } from '../types';

const StyledButton = styled(Button)`
  height: 16px;
  width: 16px;
  padding: 0;

  .anticon {
    font-size: 10px;
  }

  &&&:active,
  &&&:hover {
    background: var(--gray-medium);
  }
`;

const ShopRequestGroupTableExpandIcon = ({ expanded, onExpand, record }: AntdTableExpandIcon) => {
  const icon = expanded ? <UpOutlined /> : <DownOutlined />;
  return (
    <StyledButton type="text" onClick={(event: React.MouseEvent) => onExpand(record, event)}>
      {icon}
    </StyledButton>
  );
};

export default ShopRequestGroupTableExpandIcon;
